module.exports = __webpack_public_path__ + "assets/images/vela_4d2cddddb3743b34182af6ba8335a1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/piramide/vela.png
// module id = 215
// module chunks = 0